import { ThemeColors } from '~/themes/colors'

interface CallSoundIndicatorColors {
  Container: {
    Background: ThemeColors
  }
  Text: { FontColor: ThemeColors }
  Active: {
    Core: { Background: ThemeColors }
    Pulse: { Background: ThemeColors }
    Icon: { Color: ThemeColors }
  }
  Hold: {
    Core: { Background: ThemeColors }
    Pulse: { Background: ThemeColors }
    Icon: { Color: ThemeColors }
  }
  Mute: {
    Core: { Background: ThemeColors }
    Pulse: { Background: ThemeColors }
    Icon: { Color: ThemeColors }
  }
  Reconnecting: {
    Core: { Background: ThemeColors }
    Pulse: { Background: ThemeColors }
    Icon: { Color: ThemeColors }
  }
}

export const callSoundIndicatorColors: CallSoundIndicatorColors = {
  Container: {
    Background: {
      default: 'achromatic.transparent',
    },
  },
  Text: {
    FontColor: {
      default: 'white',
    },
  },
  Active: {
    Core: {
      Background: {
        default: 'gradients.mangoBrand.call_sound_indicator_default',
      },
    },
    Pulse: {
      Background: {
        default: 'blue.300',
      },
    },
    Icon: {
      Color: {
        default: 'blue.500',
      },
    },
  },
  Hold: {
    Core: {
      Background: {
        default: 'gray.600',
      },
    },
    Pulse: {
      Background: {
        default: 'gray.400',
      },
    },
    Icon: {
      Color: {
        default: 'white',
      },
    },
  },
  Mute: {
    Core: {
      Background: {
        default: 'blue.400',
      },
    },
    Pulse: {
      Background: {
        default: 'blue.200',
      },
    },
    Icon: {
      Color: {
        default: 'white',
      },
    },
  },
  Reconnecting: {
    Core: {
      Background: {
        default: 'gray.600',
      },
    },
    Pulse: {
      Background: {
        default: 'gray.400',
      },
    },
    Icon: {
      Color: {
        default: 'white',
      },
    },
  },
}
